import React, { useState } from 'react';
import HorseRacingBetSlipContent from './Content';
import HorseRacingAtrium from './Atrium';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import BlockUI from 'react-block-ui';
import LottieLoader from 'Components/LottieLoader';
import HorseRacingBetSlipHeader from './Header';
import HorseRacingBetSlipFooter from './Footer';
import { useDispatch, useSelector } from 'react-redux';
import { toggleHRBetSlip, verifyTJKCoupon, setHRBetslipMultiplier } from 'Store/actions/horseRacing/betSlipActions';
import { useEffect } from 'react';
import { isBetslipValid, isBetSlipEmpty } from 'Utils/horseRacingBetslipValidation';
import { withMixpanel } from 'Utils/mixpanel';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { flatten } from 'lodash';
import { isTjkPlayDisable } from 'Store/constants/horseRacing';
import { RUNWAY_TYPES } from 'Utils/horseRacesNameMapper';
import EnvironmentManager from 'Utils/environmentManager';

const HorseRacingBetSlip = ({ mixpanel }) => {
  const dispatch = useDispatch();
  const { isOpen, selectedInfos, legs, verify, footerData, combinedHorses } = useSelector(state => state.horseRacing.betSlip);
  const {  couponCount, multiplier, fixedOddMultiplier } = footerData;
  const availableBets = useSelector(state => state.horseRacing.hippodromeAvailableBets);
  const selectedHorseLegs = useSelector( state => state.horseRacing.betSlip?.legs);
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const _isLocaleValid = programType === PROGRAM_TYPES.JOINT ? isBetslipValid(selectedInfos?.selectedBet, legs) : (combinedHorses?.length > 0 );
  const isBetslipvalid = isOpen ? _isLocaleValid && !verify.error : _isLocaleValid;
  const showButton = false;
  const [selectedBet, setSelectedBet] = useState(null);

  const onClick = () => {
    dispatch(toggleHRBetSlip(!isOpen));
  };

  const headerOnClick = () => {
    dispatch(toggleHRBetSlip(!isOpen));
  };


  useEffect(() => {
    if (isOpen && _isLocaleValid) {
      dispatch(verifyTJKCoupon());
    }
  }, [selectedHorseLegs, isOpen, couponCount, multiplier, combinedHorses, fixedOddMultiplier]);

  useEffect(() => {
    if (Object.keys(selectedInfos).length > 0 && isOpen && selectedHorseLegs.length > 0) {
      const selectedLegs = selectedHorseLegs.map((data, index)=> data ? index : null).filter(item => item !== null);

      const mixpanelEvents = {
        Hippodrome: selectedInfos?.selectedHippodrome?.name,
        'Bet Type': selectedInfos?.selectedBet?.description,
        'Race Number List': selectedLegs,
        'Race Pick List': selectedInfos?.selectedRaceNumber,
        'Horse Name': flatten(selectedHorseLegs).filter(sh => sh)?.map(h => h?.name),
        'Track List': selectedInfos?.legsData?.filter(leg => selectedLegs?.includes(leg?.legNo)).map(leg=> RUNWAY_TYPES[leg?.runwayType]),
        'Horse Key List': selectedHorseLegs?.flat()?.filter(sh => sh !== undefined)?.map(h => h?.key),
        AGF: selectedHorseLegs?.flat()?.filter(sh => sh !== undefined && sh !== null)?.map(h => h.agf ? parseFloat(h.agf && h.agf?.split('%')[1]?.replace(',', '.')) : null),
        'Event First Start Time': `${selectedInfos?.selectedHippodrome?.raceDate}T${selectedInfos?.selectedHippodrome?.startTime}:00Z`,
        'Horse Count': flatten(selectedHorseLegs).filter(sh => sh)?.length,
        Odd: flatten(selectedHorseLegs).filter(sh => sh)?.map(h => h?.probableGain),
      };
      mixpanel.track('View BetSlip Detail', mixpanelEvents);
    }
  }, [isOpen, selectedHorseLegs.length, Object.keys(selectedInfos).length]);

  useEffect(() => {
    if (availableBets) setSelectedBet(availableBets?.data.find(a => a.id === availableBets.selectedBetTypeId));
  }, [availableBets]);

  useEffect(() => {
    if (programType === PROGRAM_TYPES.FIXED && combinedHorses?.length === 0 && multiplier === 1) {
      const reset = Number(EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.minimum_multiplier' }) || 20);
      dispatch(setHRBetslipMultiplier(reset));
    }
  }, [programType]);


  const betSlipClassname = classnames({
    'horse-racing-betslip': true,
    'horse-racing-betslip--active': isOpen,
    'horse-racing-betslip--invalid': !isBetslipvalid
    // 'horse-racing-betslip--empty': !isFooterVisible,
    // 'horse-racing-betslip--super-system': isVisibleSuperSystemButton
  });

  return !isTjkPlayDisable() && <React.Fragment>
    { showButton && <HorseRacingAtrium onClick={ onClick } selectedBet={ selectedInfos.selectedBet } isBetslipvalid={ isBetslipvalid }  selectedHippodrome={ selectedInfos?.selectedHippodrome } selectedHorseLegsState={ selectedHorseLegs }  /> }
    <div className={ betSlipClassname }>
      <BlockUI
        tag="div"
        className="block-ui--relative block-ui--theme-dark block-ui--100percent"
        blocking={ verify.isLoading }
        loader={ <LottieLoader type="loading" loop={ true } autoplay width="75px" /> }
        renderChildren={ true }
      >
        <div className='betslip-block-ui'>
          <HorseRacingBetSlipHeader toggleBetSlip={ headerOnClick } selectedHippodrome={ selectedInfos.selectedHippodrome } isBetslipvalid={ isBetslipvalid } />
          <HorseRacingBetSlipContent isFixedOdd={ programType === PROGRAM_TYPES.FIXED } selectedBet={ selectedInfos.selectedBet } betTypeText={ selectedBet?.description } legsData={ selectedInfos.legsData } onClose={ () => toggleHRBetSlip(false) } />
          { (programType === PROGRAM_TYPES.JOINT ?  !isBetSlipEmpty(selectedHorseLegs) : (combinedHorses?.length > 0 )) && <HorseRacingBetSlipFooter selectedInfos={ selectedInfos } isBetslipvalid={ isBetslipvalid } legs={ legs } verify={ verify }  isLocaleValid={ _isLocaleValid } /> }
        </div>
      </BlockUI>
    </div>

  </React.Fragment>;
};

HorseRacingBetSlip.propTypes = {
  mixpanel: PropTypes.object
};

export default withMixpanel(HorseRacingBetSlip);
